import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'gg-play-btn',
  templateUrl: './play-btn.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PlayBtnComponent implements OnInit {
  @Input() isPlaying: boolean;

  constructor() {
  }

  ngOnInit() {
  }


}
